<template>
  <EuiContainer >
    <EuiGrid  class="mx-0 mt-2">
      <EuiBlock  class="w-1/2" title="Whitelister une IP">
        <form @submit.prevent="validation">
          <EuiGridRow class="mt-3">
            <EuiTextField
                v-model="ip"
                label="IP à whitelister"
                adaptSize
                placeholder="Adresse IP v4"
                class="mr-3"
                />
          </EuiGridRow>
          <EuiGridRow justify="end" class="my-5" >
            <EuiButton
                :disabled="isDisabledButtonSearch"
                color="primary"
                variant="raised"
                type="submit">
              Ajouter à la whiteliste
              <EuiTooltip
                  v-show="formHasError()"
                  :content="mixinsIpGetErrorMessage"
                  placement="top">
                <template slot="anchor">
                  <EuiIcon class="eui-u-ml-4" name="help" size="medium"/>
                </template>
              </EuiTooltip>
            </EuiButton>
          </EuiGridRow>
        </form>
      </EuiBlock>
      <EuiBlock class="mt-3" title="Liste des IPs whitelistées">
        <div v-for="ip in listWhiteListedIp" :key="ip.index">
          {{ip}}
        </div>
      </EuiBlock>
    </EuiGrid>
    <ConfirmationDialog
        :isOpen="isConfirmationDialogOpen"
        @confirmation="confirmation"
        @close-dialog="closeDialog">
      <span v-html="confirmationMessage"></span>
    </ConfirmationDialog>
  </EuiContainer>
</template>

<script>
import ips from '@/mixins/ips';
import apiIp from '@/api/ip';
import ConfirmationDialog from '@/components/confirmationDialog.vue';
import store from '@/store';

export default {
  name: 'pages.ip.whitelist',
  mixins: [ips],
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      ip: '',
      listWhiteListedIp: [],
      errors: false,
      isConfirmationDialogOpen: false,
    };
  },
  mounted() {
    this.getWhiteList();
  },
  computed: {
    isDisabledButtonSearch() {
      if (this.ip === '') { return true; }
      this.mixinsIpsIsValidIpv4(this.ip);
      return this.errors;
    },
    confirmationMessage() {
      return `Ajout de l'ip <b>${this.ip}</b> <br>`
          + 'à la whitelist ?';
    },
  },
  methods: {
    closeDialog() {
      this.isConfirmationDialogOpen = false;
    },
    confirmation() {
      this.closeDialog();
      this.addIpToWhitelist();
    },
    validation() {
      this.isConfirmationDialogOpen = true;
    },
    getWhiteList() {
      this.storeStartLoading();
      apiIp.getAllWhiteListedIp({ sessionId: this.getterSession.token }).then((response) => {
        this.storeFinishLoading();
        this.listWhiteListedIp = response.content.ips.sort();
      });
    },
    parameters() {
      return {
        ip: this.ip,
        sessionId: this.getterSession.token,
      };
    },
    formHasError() {
      return this.errors;
    },
    addIpToWhitelist() {
      this.storeStartLoading();
      apiIp.unlockIpPermanently(this.parameters()).then(() => {
        store.dispatch('application/pushAlert', { message: 'L\'adresse ip a bien été ajoutée à la whitelist', type: 'success' });
        this.getWhiteList();
        this.storeFinishLoading();
      }).catch(() => {
        store.dispatch('application/pushAlert', {
          message: 'Une erreur s\'est produite. Veuillez recommencer',
          type: 'error',
        });
        this.storeFinishLoading();
      });
    },
    clearResult() {
      this.errors = false;
    },
  },
};
</script>
